import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
export default class MitigationStatus extends React.Component {
  localizedData = [
    { text: "Open", value: true },
    { text: "Closed", value: false },
  ];

  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("mitigationstatusId")){
        document.getElementById("mitigationstatusId").focus();
    }
  };

  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.value,
    });
  };

  handleEditCell = () => {
    this.props.onEditCell(this.props.dataItem, this.props.field)
  }

  render() {      
    
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;
 const riskOwnerId=this.props.riskDetails?this.props.riskDetails.userId:null;

    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (field && dataItem.inEdit === field) {
      return (
        <DropDownList
          style={ { width: "100px" } }
          onChange={ this.handleChange }
          value={ this.localizedData.find((c) => c.value === dataValue) }
          data={ this.localizedData }
          textField="text"
          id="mitigationstatusId"
        />
      )
    }
    if (dataItem.inEdit !== field) {
      if((loginUserId===ownerId||loginUserId===riskOwnerId)&&this.props.dataItem.isOpen===true){
        return (
          <td onClick={ this.handleEditCell}>
            {dataValue.toString() == "false" || dataValue.toString() == "Closed" ?
              "Closed"
              :
              "Open"
            }
          </td>
        )
      }else{
          return (
            this.props.dataItem.role == "Standard User" || this.props.dataItem.role == "View Only" ? 
            (
              <td >
              {dataValue.toString() == "false" || dataValue.toString() == "Closed"?
                "Closed"
                :
                "Open"
              }
            </td>
            ):(
              <td onClick={ this.handleEditCell }>
              {dataValue.toString() == "false" || dataValue.toString() == "Closed"?
                "Closed"
                :
                "Open"
              }
            </td>
            )
          )
        }
    }
  }
}
